import React from 'react';

import {
    SettingOutlined,
    UserOutlined,
    DashboardOutlined,
    UsergroupDeleteOutlined,
    FacebookOutlined,
    ClusterOutlined,
    FileDoneOutlined,
    QuestionCircleOutlined,
    HistoryOutlined,
    ClockCircleOutlined,
    ShopOutlined,
    DollarOutlined,
    CustomerServiceOutlined,
    DatabaseOutlined,
    EuroCircleOutlined,
    AreaChartOutlined,
    ExperimentOutlined,
    SolutionOutlined,
    MedicineBoxOutlined,
    MonitorOutlined,
    FolderOpenOutlined
} from '@ant-design/icons';

const menu = [
    {
        path: '/',
        name: 'Dashboard',
        icon: <DashboardOutlined className="sidebar-icon" />,
        permission: null
    },
    {
        path: '#',
        name: 'Cài đặt',
        icon: <SettingOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/config',
                name: 'Cài đặt hệ thống',
                permission: 'config',
                action: 'update'
            },
            {
                path: '/services',
                name: 'Danh mục dịch vụ',
                permission: 'services',
                action: 'list'
            },
            {
                path: '/procedures',
                name: 'Danh sách thủ thuật',
                permission: 'procedures',
                action: 'list'
            },
            {
                path: '/customer-care-categories',
                name: 'Danh mục CSKH',
                permission: 'customer_care_categories',
                action: 'list'
            },
            {
                path: '/instruction-templates',
                name: 'Mẫu lời dặn',
                permission: 'instruction_templates',
                action: 'list'
            },
            {
                path: '/prescription-templates',
                name: 'Mẫu đơn thuốc',
                permission: 'prescription_templates',
                action: 'list'
            },
            {
                path: '/diseases',
                name: 'Danh mục bệnh lý',
                permission: 'diseases',
                action: 'list'
            },
            {
                path: '/blood-groups',
                name: 'Nhóm máu',
                permission: 'blood_groups',
                action: 'list'
            },
            {
                path: '/customer-class',
                name: 'Hạng khách hàng',
                permission: 'customer_class',
                action: 'list'
            },
            {
                path: '/customer-status',
                name: 'Trạng thái khách hàng',
                permission: 'customer_status',
                action: 'list'
            },
            {
                path: '/interaction-statuses',
                name: 'Trạng thái tương tác',
                permission: 'interaction_statuses',
                action: 'list'
            },
            {
                path: '/interaction-types',
                name: 'Loại tương tác',
                permission: 'interaction_types',
                action: 'list'
            },
            {
                path: '/customer-sources',
                name: 'Nguồn khách hàng',
                permission: 'customer_source',
                action: 'list'
            },
            {
                path: '/units',
                name: 'Đơn vị tính',
                permission: 'unit',
                action: 'list'
            },
            {
                path: '/product-status',
                name: 'Tình trạng sản phẩm',
                permission: 'product_status',
                action: 'list'
            },
            {
                path: '/relationship-types',
                name: 'Mối quan hệ',
                permission: 'relationship_types',
                action: 'list'
            }
        ],
        //isAdminOnly: true
    },
    {
        path: '#',
        name: 'Quản lý cơ sở',
        icon: <ClusterOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/branches',
                name: 'Cơ sở',
                permission: 'branch',
                action: 'list'
            },
            {
                path: '/users',
                name: 'Nhân viên',
                permission: 'user',
                action: 'list'
            },
            {
                path: '/roles',
                name: 'Vai trò',
                permission: 'roles',
                action: 'list'
            },
            {
                path: '/role-groups',
                name: 'Nhóm vai trò',
                permission: 'role_groups',
                action: 'list'
            },
            {
                path: '/permissions',
                name: 'Phân quyền',
                permission: 'permissions',
                action: 'list'
            }
        ],
        isAdminOnly: true
    },
    {
        path: '#',
        name: 'Quản lý fanpages',
        icon: <FacebookOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/page-list',
                name: 'Danh sách fanpages',
                permission: 'page_manager',
                action: 'list'
            },
            {
                path: '/messenger',
                name: 'Messenger',
                permission: 'messenger',
                action: 'thread'
            },
            {
                path: '/zalo-oa',
                name: 'Zalo OA',
                permission: 'zalo',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Khách hàng',
        icon: <UsergroupDeleteOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/customer-groups',
                name: 'Nhóm khách hàng',
                permission: 'customer_group',
                action: 'list'
            },
            {
                path: '/customers',
                name: 'Danh sách khách hàng',
                permission: 'customer',
                action: 'list'
            },
            {
                path: '/lookup-customers?tab=all',
                name: 'Tra cứu khách hàng',
                permission: 'lookup_customer',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Khách hàng tiềm năng',
        icon: <UsergroupDeleteOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/customer-groups?potential=1',
                name: 'Nhóm KH tiềm năng',
                permission: 'customer_group',
                action: 'list'
            },
            {
                path: '/customer-prospects',
                name: 'Danh sách KH tiềm năng',
                permission: 'customer_prospect',
                action: 'list'
            }
        ]
    },
    {
        path: '/appointments?tab=1',
        name: 'Lịch hẹn',
        icon: <ClockCircleOutlined className="sidebar-icon" />,
        permission: 'appointment',
        action: 'list'
    },
    {
        path: '/telesale-follow-ups',
        name: 'Theo dõi telesale',
        icon: <CustomerServiceOutlined className="sidebar-icon" />,
        permission: 'telesale_follow_up',
        action: 'list'
    },
    {
        path: '/customer-services',
        name: 'Dịch vụ',
        icon: <DatabaseOutlined className="sidebar-icon" />,
        permission: 'customer_services',
        action: 'list'
    },
    {
        path: '#',
        name: 'Quản lý chỉnh nha',
        icon: <MedicineBoxOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/orthodontic-customers',
                name: 'Khách hàng chỉnh nha',
                permission: 'customer',
                action: 'orthodontic_customer'
            },
            {
                path: '/milestone-invisalign',
                name: 'Quản lý ca invisalign',
                permission: 'milestones',
                action: 'list'
            },
        ]
    },
    {
        path: '#',
        name: 'Bác sĩ',
        icon: <FolderOpenOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/doctor-customers',
                name: 'Danh sách bệnh nhân',
                permission: 'doctor_customers',
                action: 'list'
            },
            {
                path: '/doctor-appointments',
                name: 'Lịch hẹn khám',
                permission: 'doctor_appointments',
                action: 'list'
            },
            {
                path: '/treatment-sessions',
                name: 'Phiếu điều trị',
                permission: 'treatment_sessions',
                action: 'list'
            },
        ]
    },
    {
        path: '#',
        name: 'Thu chi',
        icon: <DollarOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/receipts',
                name: 'Phiếu thu',
                permission: 'receipt',
                action: 'list'
            },
            {
                path: '/payment-voucher',
                name: 'Phiếu chi',
                permission: 'payment_voucher',
                action: 'list'
            },
            {
                path: '/branch-funds',
                name: 'Quỹ cơ sở',
                permission: 'branch_fund',
                action: 'list'
            },
            {
                path: '/cash-book',
                name: 'Sổ quỹ',
                permission: 'cash_book',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Tính hoa hồng',
        icon: <EuroCircleOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            { path: '/commissions', name: 'Hoa hồng của tôi', permission: 'commission', action: 'employee_commission_dashboard' },
            { path: '/commission-control', name: 'Kiểm soát', permission: null },
            { path: '/commission-payout', name: 'Chi trả', permission: null },
            { path: '/commission-policies', name: 'Chính sách hoa hồng', permission: 'commission_config', action: 'view' },
            { path: '/commission-service-policies', name: 'Chính sách dịch vụ', permission: 'commission_config', action: 'view' }
        ]
    },
    {
        path: '#',
        name: 'Báo cáo thống kê',
        icon: <AreaChartOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/revenue-report',
                name: 'Doanh thu & doanh số',
                permission: 'statistics',
                action: 'revenue'
            },
            {
                path: '/staff-revenue-yearly',
                name: 'Doanh số nhân viên (năm)',
                permission: 'statistics',
                action: 'staff_revenue_yearly'
            },
            {
                path: '/staff-revenue-report',
                name: 'Doanh số nhân viên chi tiết',
                permission: 'statistics',
                action: 'staff_revenue_detail'
            },
            {
                path: '/staff-income-report',
                name: 'Doanh thu nhân viên',
                permission: 'statistics',
                action: 'staff_revenue_detail'
            },
            {
                path: '/assistants-support-cases',
                name: 'Ca hỗ trợ của phụ tá',
                permission: 'statistics',
                action: 'assistants_support_cases'
            },
            {
                path: '/customer-visits',
                name: 'Thống kê lượt khách đến',
                permission: 'statistics',
                action: 'customer_visits'
            }
        ]
    },
    {
        path: '/monitoring',
        name: 'Giám sát vận hành',
        icon: <MonitorOutlined className="sidebar-icon" />,
        permission: 'monitorings',
        action: 'view'
    },
    {
        path: '#',
        name: 'Quản lý Labo',
        icon: <ExperimentOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/labo-statistics',
                name: 'Thống kê',
                permission: 'labo_cases',
                action: 'status_statistics, customer_statistics'
            },
            {
                path: '/labo-cases',
                name: 'Ca gửi Labo',
                permission: 'labo_cases',
                action: 'list'
            },
            {
                path: '/labos',
                name: 'Đối tác Labo',
                permission: 'labos',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Kho',
        icon: <ShopOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/warehouse',
                name: 'Danh sách kho',
                permission: 'product_warehouse',
                action: 'list'
            },
            {
                path: '/product-supplier',
                name: 'Nhà cung cấp',
                permission: 'product_supplier',
                action: 'list'
            },
            {
                path: '/product-group',
                name: 'Nhóm sản phẩm',
                permission: 'product_group',
                action: 'list'
            },
            {
                path: '/product-list',
                name: 'Sản phẩm',
                permission: 'product',
                action: 'list'
            },
            {
                path: '/product-statistics',
                name: 'Thống kê tồn kho',
                permission: 'product',
                action: 'statistics'
            },
            {
                path: '/receipt-import',
                name: 'Phiếu nhập',
                permission: 'product_receipt_import',
                action: 'list'
            },
            {
                path: '/receipt-export',
                name: 'Phiếu xuất',
                permission: 'product_receipt_export',
                action: 'list'
            }
        ]
    },
    {
        path: '/work-report',
        name: 'Báo cáo công việc',
        icon: <FileDoneOutlined className="sidebar-icon" />,
        permission: 'work_report'
    },
    {
        path: '#',
        name: 'Hoạt động',
        icon: <HistoryOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/audit-logs',
                name: 'Lịch sử thay đổi',
                permission: 'audit_logs',
                action: 'search'
            },
            {
                path: '/view-phonenumber',
                name: 'Lịch sử xem số điện thoại',
                permission: 'view_phonenumber',
                action: 'list'
            }
        ]
    },
    {
        path: '/guide',
        name: 'Hướng dẫn sử dụng',
        icon: <QuestionCircleOutlined className="sidebar-icon" />,
        permission: 'guide'
    },
    {
        path: '/feedback-requests',
        name: 'Yêu cầu chỉnh sửa',
        icon: <SolutionOutlined className="sidebar-icon" />,
        permission: 'feedback_requests'
    },
    {
        path: '#',
        name: 'Đối tác',
        icon: <SolutionOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/partner-customers',
                name: 'Danh sách khách hàng',
                permission: 'partner_customers',
                action: 'list'
            }
        ]
    },
    {
        path: '/profile',
        name: 'Thông tin tài khoản',
        icon: <UserOutlined className="sidebar-icon" />,
        permission: null,
    }
];

export default menu;
